import { useQuery } from '@tanstack/react-query';
import { FloodZoneResponse } from '../models/floodzone.models';
import { getAuthenticated } from './api';

export const useGetFloodData = (
  latitude: number | undefined,
  longitude: number | undefined
) => {
  const url = `land/floodzone?latitude=${latitude}&longitude=${longitude}`;
  const { isPending, error, data } = useQuery<FloodZoneResponse>({
    queryKey: ['flood-zone', latitude, longitude],
    queryFn: async () => {
      return getAuthenticated<FloodZoneResponse>(url);
    },
  });
  return {
    loading: isPending,
    error,
    data: data?.result || undefined,
  };
};
